import React, { useState } from "react";
import Header from "../_components/_global/WelcomeHeader";

const WatchDemo = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [activeChapter, setActiveChapter] = useState(0);

  const chapters = [
    {
      time: "00:00",
      title: "Overview",
      subtitle: "Introduction to CityGetAway",
    },
    {
      time: "01:10",
      title: "Create itinerary",
      subtitle: "AI-powered trip planning",
    },
    {
      time: "03:00",
      title: "Real-time navigation",
      subtitle: "Never get lost again",
    },
    {
      time: "04:20",
      title: "Adaptive changes",
      subtitle: "Dynamic route optimization",
    },
  ];

  const keyTakeaways = [
    {
      icon: "🎯",
      title: "AI-Powered Planning",
      description:
        "Create personalized itineraries in seconds based on your preferences",
    },
    {
      icon: "🗺️",
      title: "Real-Time Navigation",
      description:
        "Turn-by-turn directions with live traffic and transit updates",
    },
    {
      icon: "💡",
      title: "Smart Recommendations",
      description: "Discover hidden gems and local favorites along your route",
    },
  ];

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", Arial, sans-serif;
          background: #ffffff;
          color: #1a1a1a;
        }
        
        .watch-demo-container {
          min-height: 100vh;
          background: #ffffff;
          padding-top: 80px;
        }
        
        .demo-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }
        
        /* Hero Section */
        .demo-hero {
          text-align: center;
          margin-bottom: 50px;
        }
        
        .demo-title {
          font-size: 48px;
          font-weight: 600;
          color: #0f1720;
          margin-bottom: 20px;
          font-family: "Segoe UI", sans-serif;
        }
        
        .demo-subtitle {
          font-size: 18px;
          color: #6b7280;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
          font-weight: 400;
        }
        
        /* Video Section */
        .video-wrapper {
          background: #f9fafb;
          border-radius: 16px;
          padding: 8px;
          margin-bottom: 60px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        
        .video-player {
          background: linear-gradient(135deg, #2a3f5f 0%, #1e293b 100%);
          border-radius: 12px;
          aspect-ratio: 16/9;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          cursor: pointer;
          overflow: hidden;
        }
        
        .play-button {
          width: 72px;
          height: 72px;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        
        .video-player:hover .play-button {
          transform: scale(1.1);
          background: #ffffff;
        }
        
        .play-icon {
          width: 0;
          height: 0;
          border-left: 20px solid #2a3f5f;
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
          margin-left: 4px;
        }
        
        .video-info {
          position: absolute;
          bottom: 30px;
          text-align: center;
        }
        
        .video-label {
          color: rgba(255, 255, 255, 0.95);
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 6px;
        }
        
        .video-duration {
          color: rgba(255, 255, 255, 0.7);
          font-size: 14px;
        }
        
        .video-controls {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 16px 20px;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
          display: flex;
          align-items: center;
          gap: 16px;
          opacity: 0;
          transition: opacity 0.3s;
        }
        
        .video-player:hover .video-controls {
          opacity: 1;
        }
        
        .control-btn {
          background: none;
          border: none;
          color: white;
          font-size: 16px;
          cursor: pointer;
          padding: 4px;
          opacity: 0.9;
          transition: opacity 0.2s;
        }
        
        .control-btn:hover {
          opacity: 1;
        }
        
        .progress-bar {
          flex: 1;
          height: 3px;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 2px;
          cursor: pointer;
        }
        
        .progress-fill {
          height: 100%;
          background: white;
          width: 35%;
          border-radius: 2px;
        }
        
        .time-display {
          color: white;
          font-size: 13px;
          opacity: 0.9;
        }
        
        .keyboard-shortcuts {
          padding: 16px;
          text-align: center;
          color: #6b7280;
          font-size: 13px;
        }
        
        /* Content Grid */
        .content-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
          margin-bottom: 60px;
        }
        
        .content-section {
          background: #ffffff;
        }
        
        .section-title {
          font-size: 24px;
          font-weight: 600;
          color: #0f1720;
          margin-bottom: 24px;
          font-family: "Segoe UI", sans-serif;
        }
        
        /* Chapters */
        .chapter-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        
        .chapter-item {
          display: flex;
          align-items: flex-start;
          padding: 14px 16px;
          background: #f9fafb;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: 1px solid transparent;
        }
        
        .chapter-item:hover {
          background: #f3f4f6;
          border-color: #e5e7eb;
        }
        
        .chapter-item.active {
          background: #eff6ff;
          border-color: #3b82f6;
        }
        
        .chapter-time {
          color: #6b7280;
          font-size: 14px;
          min-width: 45px;
          margin-right: 16px;
          padding-top: 2px;
        }
        
        .chapter-info {
          flex: 1;
        }
        
        .chapter-title {
          color: #1f2937;
          font-size: 15px;
          font-weight: 500;
          margin-bottom: 4px;
        }
        
        .chapter-subtitle {
          color: #6b7280;
          font-size: 13px;
          line-height: 1.4;
        }
        
        /* Key Takeaways */
        .takeaway-list {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        
        .takeaway-item {
          display: flex;
          align-items: flex-start;
          gap: 14px;
        }
        
        .takeaway-icon {
          width: 40px;
          height: 40px;
          background: #10b981;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 20px;
          flex-shrink: 0;
        }
        
        .takeaway-content {
          flex: 1;
        }
        
        .takeaway-title {
          color: #1f2937;
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 6px;
        }
        
        .takeaway-description {
          color: #6b7280;
          font-size: 14px;
          line-height: 1.5;
        }
        
        /* Accessibility Section */
        .accessibility-section {
          background: #f9fafb;
          border-radius: 12px;
          padding: 40px;
          margin-bottom: 60px;
        }
        
        .accessibility-title {
          font-size: 28px;
          font-weight: 600;
          color: #0f1720;
          text-align: center;
          margin-bottom: 32px;
        }
        
        .accessibility-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px 40px;
        }
        
        .accessibility-feature {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }
        
        .check-icon {
          color: #10b981;
          font-size: 20px;
          margin-top: 2px;
        }
        
        .feature-content {
          flex: 1;
        }
        
        .feature-title {
          color: #1f2937;
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 4px;
        }
        
        .feature-description {
          color: #6b7280;
          font-size: 14px;
          line-height: 1.4;
        }
        
        /* Responsive */
        @media (max-width: 768px) {
          .demo-title {
            font-size: 36px;
          }
          
          .demo-subtitle {
            font-size: 16px;
          }
          
          .content-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }
          
          .accessibility-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          
          .demo-content {
            padding: 40px 20px;
          }
        }
      `}</style>

      <Header />

      <div className="watch-demo-container">
        <div className="demo-content">
          {/* Hero Section */}
          <div className="demo-hero">
            <h1 className="demo-title">See CityGetAway in action</h1>
            <p className="demo-subtitle">
              Watch how our AI-powered platform transforms the way you explore
              cities around the world
            </p>
          </div>

          {/* Video Player */}
          <div className="video-wrapper">
            <div
              className="video-player"
              onClick={() => setIsPlaying(!isPlaying)}
            >
              {!isPlaying && (
                <>
                  <div className="play-button">
                    <div className="play-icon"></div>
                  </div>
                  <div className="video-info">
                    <div className="video-label">Demo Video</div>
                    <div className="video-duration">4:47 minutes</div>
                  </div>
                </>
              )}

              <div className="video-controls">
                <button className="control-btn">▶</button>
                <div className="progress-bar">
                  <div className="progress-fill"></div>
                </div>
                <span className="time-display">1:40 / 4:47</span>
                <button className="control-btn">🔊</button>
                <button className="control-btn">⛶</button>
              </div>
            </div>

            <div className="keyboard-shortcuts">
              Keyboard shortcuts: Space (play/pause) · M (mute) · F (fullscreen)
              · C (captions)
            </div>
          </div>

          {/* Chapters and Key Takeaways */}
          <div className="content-grid">
            <div className="content-section">
              <h2 className="section-title">Chapters</h2>
              <div className="chapter-list">
                {chapters.map((chapter, index) => (
                  <div
                    key={index}
                    className={`chapter-item ${
                      activeChapter === index ? "active" : ""
                    }`}
                    onClick={() => setActiveChapter(index)}
                  >
                    <span className="chapter-time">{chapter.time}</span>
                    <div className="chapter-info">
                      <div className="chapter-title">{chapter.title}</div>
                      <div className="chapter-subtitle">{chapter.subtitle}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="content-section">
              <h2 className="section-title">Key Takeaways</h2>
              <div className="takeaway-list">
                {keyTakeaways.map((takeaway, index) => (
                  <div key={index} className="takeaway-item">
                    <div
                      className="takeaway-icon"
                      style={{
                        background:
                          index === 0
                            ? "#3b82f6"
                            : index === 1
                            ? "#10b981"
                            : "#f59e0b",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      {index === 0 && "AI"}
                      {index === 1 && "GPS"}
                      {index === 2 && "REC"}
                    </div>
                    <div className="takeaway-content">
                      <div className="takeaway-title">{takeaway.title}</div>
                      <div className="takeaway-description">
                        {takeaway.description}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Accessibility Features */}
          <div className="accessibility-section">
            <h2 className="accessibility-title">Accessibility Features</h2>
            <div className="accessibility-grid">
              <div className="accessibility-feature">
                <span className="check-icon">✓</span>
                <div className="feature-content">
                  <div className="feature-title">Closed Captions</div>
                  <div className="feature-description">
                    Full subtitles available in multiple languages
                  </div>
                </div>
              </div>
              <div className="accessibility-feature">
                <span className="check-icon">✓</span>
                <div className="feature-content">
                  <div className="feature-title">Full Transcript</div>
                  <div className="feature-description">
                    Complete text version of the video content
                  </div>
                </div>
              </div>
              <div className="accessibility-feature">
                <span className="check-icon">✓</span>
                <div className="feature-content">
                  <div className="feature-title">Keyboard Controls</div>
                  <div className="feature-description">
                    Navigate using keyboard shortcuts
                  </div>
                </div>
              </div>
              <div className="accessibility-feature">
                <span className="check-icon">✓</span>
                <div className="feature-content">
                  <div className="feature-title">Screen Reader Support</div>
                  <div className="feature-description">
                    Fully compatible with screen reading software
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WatchDemo;
